import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile, KeycloakTokenParsed } from 'keycloak-js';
import { AppState, selectUsuario } from '../store';
import { Store } from '@ngrx/store';
import { UsuarioNovo } from '../store/usuario/usuario.actions';
import { map, of, switchMap } from 'rxjs';
import { getCookie, deleteCookie } from '../utils/geral';

@Injectable()
export class AuthService {
  constructor(private keycloak: KeycloakService, private store: Store<AppState>) {}

  getLoggedUser(): KeycloakTokenParsed | undefined {
    try {
      const userDetails: KeycloakTokenParsed | undefined = this.keycloak.getKeycloakInstance().idTokenParsed;
      return userDetails;
    } catch (e) {
      console.error('Exception', e);
      return undefined;
    }
  }

  public isLoggedIn(): Promise<boolean> {
    return this.keycloak.isLoggedIn();
  }

  public loadUserProfile(): Promise<KeycloakProfile | undefined> {
    return new Promise<KeycloakProfile>((resolve, reject) => {
      this.store.select(selectUsuario).subscribe((u: any) => {
        if (u.id) {
          let profile: KeycloakProfile = <KeycloakProfile>u;
          resolve(profile);
        } else {
          let prom = this.keycloak.loadUserProfile();
          prom.then((profile) => this.store.dispatch(new UsuarioNovo({ user: profile })));
          resolve(prom);
        }
      });
    });
  }

  public refreshUsuarioStore(user: any) {
    delete user.password;
    this.store.dispatch(new UsuarioNovo({ user: user }));
  }

  // public login(): void {
  //     this.keycloak.login().then(() => {
  //         this.loadUserProfile().then(u => {
  //             let usuario = {
  //                 id: u.id,
  //                 username: u.username,
  //                 email: u.email,
  //                 nome: u.firstName,
  //                 portal_cedente: (<any>u).attributes.portal_cedente,
  //                 portal_sacado: (<any>u).attributes.portal_sacado
  //             };

  //             this.store.dispatch(new UsuarioNovo({ user: usuario }))
  //         });
  //     });
  // }

  public logout(): void {
    const cookie = getCookie('tenant_id');
    deleteCookie('tenant_id');
    this.keycloak.logout(window.location.origin + '/' + cookie);
  }

  public redirectToProfile(): void {
    this.keycloak.getKeycloakInstance().accountManagement();
  }

  public getRoles(): string[] {
    return this.keycloak.getUserRoles();
  }
}
